import axios from 'axios';
const getApiKey = async () => {
  const apiKeyArray = [
    'OCVD0MP2749DE3QV',
    'VTRRDL6QMKR4UKIY',
    'TEIQP34UY56W40W5',
  ];
  const randomIndex = Math.floor(Math.random() * apiKeyArray.length);
  return apiKeyArray[randomIndex];
};

const GetCompanyPrice = async (ticker) => {
  const apiKey = await getApiKey();
  const data = axios
    .get(
      `https://www.alphavantage.co/query?function=GLOBAL_QUOTE&symbol=${ticker}&apikey=${apiKey}`
    )
    .then((response) => {
      return response.data['Global Quote'];
    })
    .catch((error) => {
      console.error(error);
    });
  return data;
};

export default GetCompanyPrice;
